<template>
  <Modal v-model="addAttributesModal" class-name="addAttributesStyle" :title="$t('key1000405')" width="1200"
    :transfer="false" :mask-closable="false" @on-visible-change="addAttributesChange">
    <Form ref="addAttributesForm" :model="addAttributesForm" :label-width="100"
      :disabled="addAttributesTalg === 'look'" @submit.native.prevent>
      <Row>
        <!--站点-->
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000472')" prop="ymsSiteId" :label-width="80">
            <Select v-model="addAttributesForm.ymsSiteId" transfer filterable class="width_200">
              <Option v-for="item in ymsSiteList" :key="item.ymsSiteId" :value="item.ymsSiteId">{{ item.siteName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <!--规格/普通属性-->
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000473')" class="radio_styles" prop="attributeType">
            <RadioGroup v-model="addAttributesForm.attributeType">
              <Radio v-for="item in attributeTypeList" :key="item.value" :label="item.value" :disabled="true">
                {{ item.name }}
              </Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <!--属性值类型-->
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="addAttributesForm.attributeType ===0">
          <Form-item :label="$t('key1000474')" class="radio_styles" prop="type">
            <RadioGroup v-model="addAttributesForm.type" @on-change="typeChange">
              <Radio v-for="item in attributeValueTypeList" :key="item.value" :label="item.value">{{ item.name }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <!--属性值单选/多选-->
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="!isAllowCustomValueTalg && addAttributesForm.type !==0">
          <Form-item :label="$t('key1000475')" class="radio_styles" prop="chooseType">
            <RadioGroup v-model="addAttributesForm.chooseType">
              <Radio :label="0">{{ $t('key1000395') }}</Radio>
              <Radio :label="1">{{ $t('key1000394') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <!--填写要求-->
        <Col :xxl="addAttributesForm.attributeType === 0 ? threeItemCol : fourItemCol"
          :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-if="!isAllowCustomValueTalg || addAttributesForm.attributeType === 1">
          <Form-item :label="$t('key1000476')" class="radio_styles" prop="attributeRequire">
            <RadioGroup v-model="addAttributesForm.attributeRequire">
              <Radio :label="0">{{ $t('key1000304') }}</Radio>
              <Radio :label="1">{{ $t('key1000305') }}</Radio>
              <Radio :label="2" v-if="addAttributesForm.attributeType !==1">{{ $t('key1000306') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <!--是否尺码属性-->
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000477')" class="radio_styles" prop="isSizeAttribute">
            <RadioGroup v-model="addAttributesForm.isSizeAttribute">
              <Radio :label="0">{{ $t('key1000393') }}</Radio>
              <Radio :label="1">{{ $t('key1000392') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <!--是否需填写比例-->
        <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol"
          v-if="(!isAllowCustomValueTalg && addAttributesForm.chooseType === 0) && addAttributesForm.type !==0">
          <Form-item :label="$t('key1000478')" class="radio_styles" prop="isProportion">
            <RadioGroup v-model="addAttributesForm.isProportion">
              <Radio :label="0">{{ $t('key1000393') }}</Radio>
              <Radio :label="1">{{ $t('key1000392') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <Row>
      <!--属性名称-->
      <Col :xxl="oneItemCol" style="margin: 12px 0;">
        <Card dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1000479') }}</h2>
          </template>
          <div class="table_box">
            <Table border :columns="attrTableColumns" :data="attrTableData"></Table>
          </div>
        </Card>
      </Col>
      <!--属性单位-->
      <Col :xxl="oneItemCol" style="margin: 12px 0;" v-if="attributeUnitTalg">
        <Card dis-hover>
          <template #title>
            <h2 class="title_box flex">{{ $t('key1000480') }}</h2>
          </template>
          <div class="table_box attributeUnitTableDom">
            <!--尺码组名-->
            <div class="flex align-items-start mt10">
              <div class="required">{{ $t('key1000481') }}</div>
              <CheckboxGroup v-model="sizeGroupNameList" class="flex flex-wrap" style="width: 92%;">
                <div class="sizeGroupName_box" v-for="item in sizeGroupNameData">
                  <Checkbox class="sizeGroupName_item" :label="item.key" :disabled="item.disabled || addAttributesTalg === 'look'">
                    {{ item.name }}
                  </Checkbox>
                  <span v-if="sizeGroupNameList.includes(item.key) && !item.disabled && addAttributesTalg !== 'look'"
                    class="options_item" @click="changeValue(item.key)"></span>
                </div>
              </CheckboxGroup>
            </div>
            <Table
              ref="attributeUnitDom"
              border
              :columns="attributeUnitColumns"
              max-height="450"
              :data="attributeUnitData">
            </Table>
            <h2 class="themeColor mt10 cursor display-inline-block" v-if="addAttributesTalg !== 'look'" @click="addAttributeUnit">+ {{ $t('key1000482') }}</h2>
          </div>
        </Card>
      </Col>
      <!--可选值-->
      <Col :xxl="oneItemCol" style="margin: 12px 0;" v-if="addAttributesForm.type === 1">
        <Card dis-hover>
          <template #title>
            <h2 class="title_box flex">
              <span>{{ $t('key1000483') }}</span>
              <Checkbox class="ml10" v-model="isAllowCustomValue" :disabled="isAllowCustomValueTalg">{{ $t('key1000484') }}</Checkbox>
            </h2>
          </template>
          <div class="table_box attributeValuetableDom">
            <!--尺码组名-->
            <div class="flex align-items-start mt10">
              <div class="required">{{ $t('key1000481') }}</div>
              <CheckboxGroup v-model="sizeGroupNameList" class="flex flex-wrap" style="width: 92%;">
                <div class="sizeGroupName_box" v-for="item in sizeGroupNameData">
                  <Checkbox class="sizeGroupName_item" :label="item.key" :disabled="item.disabled || addAttributesTalg === 'look'">
                    {{ item.name }}
                  </Checkbox>
                  <span v-if="sizeGroupNameList.includes(item.key) && !item.disabled && addAttributesTalg !== 'look'"
                    class="options_item" @click="changeValue(item.key)"></span>
                </div>
              </CheckboxGroup>
            </div>
            <Table
              ref="tableDom"
              border
              :columns="optionalTableColumns"
              max-height="450"
              :draggable="draggable"
              @on-drag-drop="dragDrop"
              :data="optionalTableData">
            </Table>
            <h2 class="themeColor mt10 cursor display-inline-block" v-if="addAttributesTalg !== 'look'" @click="addOptional">+ {{ $t('key1000485') }}</h2>
          </div>
        </Card>
      </Col>
    </Row>
    <template #footer>
      <Button @click="addAttributesModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="addAttributesBtn" v-if="addAttributesTalg === 'add' || addAttributesTalg === 'edit'">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getDataSetBatchList, handerDataSorting, getEnumList} from "@/utils/common";

export default {
  name: 'addAttributes',
  mixins: [Mixin],
  props: {
    ymsSiteList: {
      type: Array,
      default: () => []
    },
    attributeTalg: {
      type: String,
      default: null
    }
  },
  data() {
    let v = this;
    return {
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      addAttributesModal: false,
      isAllowCustomValue: false,
      addAttributesTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000428'),
      addAttributesTalg: 'add', // add 新增   edit 编辑   look 查看
      addAttributesForm: {
        attributeType: 0, // 属性类型 0 基础属性 1 规格属性
        attributeRequire: 0, // 填写要求
        type: 1, // 属性值类型
        chooseType: 0, // 属性值单选/多选
        isSizeAttribute: 0, // 是否尺码属性
        isProportion: 0, // 是否需填写比例
        ymsSiteId: null, // 站点
      },
      attrTableData: [{
        cnName: '',
        deName: '',
        usName: '',
        ukName: '',
        auName: '',
        euName: '',
        esName: '',
        frName: '',
        itName: '',
        nlName: '',
        plName: '',
        ptName: '',
        roName: '',
      }], // 属性名称列表
      optionalTableData: [{
        cnValue: '',
        deValue: '',
        usValue: '',
        ukValue: '',
        auValue: '',
        euValue: '',
        esValue: '',
        frValue: '',
        itValue: '',
        nlValue: '',
        plValue: '',
        ptValue: '',
        roValue: '',
        sortNo: 1,
        status: 1,
        addTalg: true,
        introduction: '',
        referenceImagePath: ''
      }],
      // 可选值列表
      attrTableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000429'),
          key: 'cnName',
          align: 'center',
          minWidth: 130,
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000430'),
          key: 'usName',
          align: 'center',
          minWidth: 130,
          renderHeader: (h, params) => {
            return h('span', {class: 'required'}, params.column.title);
          },
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000431'),
          key: 'ukName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000432'),
          key: 'auName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000433'),
          key: 'euName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000434'),
          key: 'frName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000435'),
          key: 'deName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000436'),
          key: 'esName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000437'),
          key: 'nlName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000438'),
          key: 'plName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000439'),
          key: 'ptName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000440'),
          key: 'itName',
          align: 'center',
          minWidth: 130,
          render: (h, params) => v.attributeNameRender(h, params)
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000441'),
          key: 'roName',
          align: 'center',
          minWidth: 140,
          render: (h, params) => v.attributeNameRender(h, params)
        }
      ],
      optionalTableColumns: [],
      attributeUnitColumns: [],
      attributeUnitData: [{
        cnValue: '',
        deValue: '',
        usValue: '',
        ukValue: '',
        auValue: '',
        euValue: '',
        esValue: '',
        frValue: '',
        itValue: '',
        nlValue: '',
        plValue: '',
        ptValue: '',
        roValue: '',
        sortNo: 1,
        status: 1,
        addTalg: true
      }],
      newAttributeTalg: false,
      repeatObj: {},
      attributePoolList: [],
      attributeNameObj: {},
      draggable: false,
      isAllowCustomValueTalg: false,
      attributeDetails: {},
      attributeTypeTalg: false,
      valueKeyList: ['cnValue', 'deValue', 'usValue', 'ukValue', 'auValue', 'euValue',
        'esValue', 'frValue', 'itValue', 'nlValue', 'plValue', 'ptValue', 'roValue'],
      sizeGroupNameList: ['cnValue', 'usValue'],
      optionalValuesData: [{
        cnValue: '',
        deValue: '',
        usValue: '',
        ukValue: '',
        auValue: '',
        euValue: '',
        esValue: '',
        frValue: '',
        itValue: '',
        nlValue: '',
        plValue: '',
        ptValue: '',
        roValue: '',
        sortNo: 1,
        status: 1,
        addTalg: true,
        introduction: '',
        referenceImagePath: ''
      }],
      enumData: []
    };
  },
  computed: {
    attributeUnitTalg() {
      return this.addAttributesForm.type === 0 && this.addAttributesForm.attributeType === 0;
    },
    //属性值类型
    attributeValueTypeList() {
      const ENUM_KEY = 'YmsProductAttributeValueTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    attributeTypeList() {
      const ENUM_KEY = 'YmsPlatformOrderYmsAbnormalStatusDistributorEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 尺码组名称
    sizeGroupNameData() {
      const isSize = this.addAttributesForm.isSizeAttribute;
      const suffix = isSize === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000442') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000443');
      return [
        {disabled: true, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000429'), key: 'cnValue'},
        {disabled: true, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000430'), key: 'usValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000431'), key: 'ukValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000432'), key: 'auValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000433'), key: 'euValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000444') + suffix, key: 'frValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000445') + suffix, key: 'deValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000446') + suffix, key: 'esValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000447') + suffix, key: 'nlValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000448') + suffix, key: 'plValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000449') + suffix, key: 'ptValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000450') + suffix, key: 'itValue'},
        {disabled: false, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000451') + suffix, key: 'roValue'},
      ];
    }
  },
  methods: {
    // 初始化数据
    async initAttributesData(type, item, commodityType) {
      let v = this;
      let enumKeyList = ['YmsProductAttributeValueTypeCoreEnum', 'YmsPlatformOrderYmsAbnormalStatusDistributorEnum'];
      v.enumData = await getDataSetBatchList(enumKeyList);
      v.handleColumns();
      v.addAttributesTalg = type;
      let filedList = ['attributeRequire', 'isProportion', 'type', 'chooseType', 'isSizeAttribute', 'attributeType'];
      if (type !== 'add') {
        let ymsProductAttributeTemplateId = item.ymsProductAttributeTemplateId || null;
        v.sizeGroupNameList = [];
        function handleData(data) {
          if (data) {
            filedList.map((key) => {
              v.addAttributesForm[key] = data[key];
            });
            let ymsProductAttributeTemplateSiteRelations = data.ymsProductAttributeTemplateSiteRelations || [];
            if (ymsProductAttributeTemplateSiteRelations.length > 0) {
              v.addAttributesForm.ymsSiteId = ymsProductAttributeTemplateSiteRelations[0].ymsSiteId;
            } else {
              v.addAttributesForm.ymsSiteId = item.ymsSiteId;
            }
            v.isAllowCustomValue = data.isAllowCustomValue !== '0';
            if (v.addAttributesForm.attributeType === 1) {
              v.isAllowCustomValueTalg = true;
              v.isAllowCustomValue = false;
            } else {
              v.isAllowCustomValueTalg = false;
            }
            // 属性名称
            let new_arr = ['cnName', 'deName', 'usName', 'ukName', 'auName', 'euName', 'esName',
              'frName', 'itName', 'nlName', 'plName', 'ptName', 'roName', 'ymsProductAttributeTemplateId'];
            let obj = {};
            new_arr.map((item) => {
              obj[item] = data[item];
            });
            v.attrTableData = [];
            if (Object.keys(obj).length > 0) {
              v.attrTableData.push(obj);
            }
            // 可选值
            let list = data.productAttributeDictionaryBos || data.values;
            if (list.length > 0) {
              // 默认的sortNo都是为0时，默认拿列表序号值
              let talg = list.every((item) => {
                return item.sortNo === 0;
              });
              if (talg) {
                list.map((item, index) => {
                  item.sortNo = index + 1;
                });
              }
              let obj = list[0];
              for (let key in obj) {
                if (v.valueKeyList.includes(key) && obj[key]) {
                  v.sizeGroupNameList.push(key);
                }
              }
              let data = list.sort(handerDataSorting('sortNo', 'asc'));
              v.optionalValuesData = JSON.parse(JSON.stringify(data));
              v.optionalTableData = data;
              v.attributeUnitData = data;
            }
            v.attributeDetails = data;
            v.getAttributePoolData();
            v.addAttributesModal = true;
          }
        }
        if (ymsProductAttributeTemplateId) {
          v.axios.get(api.get_ymsProductAttributeTemplate + ymsProductAttributeTemplateId, {loading: true}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              handleData(data);
            }
          });
        } else {
          handleData(item);
        }
      } else {
        v.optionalValuesData = JSON.parse(JSON.stringify(v.optionalTableData));
        v.sizeGroupNameList = v.sizeGroupNameData.filter(item => item.disabled).map(item => item.key);
        v.addAttributesForm.ymsSiteId = v.ymsSiteList[0].ymsSiteId;
        if (commodityType === 'specifications') {
          v.addAttributesForm.attributeType = 1;
          v.attributeTypeTalg = true;
        } else if (commodityType === 'attribute') {
          v.addAttributesForm.attributeType = 0;
          v.attributeTypeTalg = true;
        }
        if (v.addAttributesForm.attributeType === 1) {
          v.isAllowCustomValueTalg = true;
          v.isAllowCustomValue = false;
        } else {
          v.isAllowCustomValueTalg = false;
        }
        v.getAttributePoolData();
        v.addAttributesModal = true;
      }
    },
    // 新增属性的确定按钮
    addAttributesBtn() {
      let v = this;
      let method = '';
      let url = '';
      let txt = '';
      let query = {
        attributeType: v.addAttributesForm.attributeType,
        attributeRequire: v.addAttributesForm.attributeRequire,
        isProportion: v.addAttributesForm.isProportion,
        chooseType: v.addAttributesForm.chooseType,
        type: v.addAttributesForm.type,
        isSizeAttribute: v.addAttributesForm.isSizeAttribute,
        isAllowCustomValue: v.isAllowCustomValue ? 1 : 0,
        values: [],
        ymsSiteId: v.addAttributesForm.ymsSiteId,
      };
      // 校验多语种的属性名称不能相同（不能重复创建）
      if (v.attributePoolList.length > 0) {
        let newList = [];
        let keyList = [
          'cnName',
          'deName',
          'usName',
          'ukName',
          'auName',
          'euName',
          'esName',
          'frName',
          'itName',
          'nlName',
          'plName',
          'ptName',
          'roName'
        ];
        let nameObj = {};
        v.attributeNameObj = {};
        if (v.addAttributesTalg === 'edit') {
          newList = v.attributePoolList.filter(item => {
            return item.cnName !== v.attributeDetails.cnName;
          });
        } else {
          query.status = 1; // 新增属性默认是启用状态
          newList = v.attributePoolList;
        }
        if (newList.length > 0) {
          newList.map((item) => {
            for (let key in item) {
              if (keyList.includes(key)) {
                nameObj[key] = nameObj[key] || [];
                if (item[key]) {
                  nameObj[key].push(item[key]);
                }
              }
            }
          });
          for (let key in nameObj) {
            let list = nameObj[key];
            v.attributeNameObj[key] = v.uniqueFunc(list);
          }
          if (Object.keys(v.attributeNameObj).length > 0) {
            for (let j = 0; j < v.attrTableData.length; j++) {
              let ele = v.attrTableData[j];
              for (let key in ele) {
                if (keyList.includes(key)) {
                  let newList = v.attributeNameObj[key];
                  if (newList.includes(ele[key])) {
                    v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000452'));
                    return false;
                  }
                }
              }
            }
          }
        }
      }

      // 校验属性名称（中、英文属性名称必填）
      if (v.attrTableData.length > 0) {
        let nameList = ['cnName', 'usName'];
        for (let item of v.attrTableData) {
          for (let key in item) {
            if (nameList.includes(key) && !item[key]) {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000453'));
              return false;
            } else {
              query[key] = item[key];
            }
          }
        }
      }

      if (v.optionalValuesData.length > 0) {
        v.repeatObj = {};
        let newListObj = {};
        for (let i = 0; i < v.optionalValuesData.length; i++) {
          let items = v.optionalValuesData[i];
          for (let key in items) {
            if (v.sizeGroupNameList.includes(key)) {
              newListObj[key] = newListObj[key] || [];
              if (items[key]) {
                newListObj[key].push(items[key]);
              }
            }
          }
        }
        // 校验同一个语种下的属性值要必填
        if (Object.keys(newListObj).length > 0) {
          for (let key in newListObj) {
            if (v.sizeGroupNameList.includes(key)) {
              let list = newListObj[key];
              if (list.length <= 0 || v.optionalValuesData.length !== list.length) {
                v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000454'));
                v.scrollToError();
                return false;
              }
            }
          }
        }
        // 校验同一个语种下的属性值不能相同
        for (let key in newListObj) {
          let list = newListObj[key];
          v.repeatObj[key] = v.uniqueFunc(list.filter(i => list.indexOf(i) !== list.lastIndexOf(i)));
        }
        for (let key in newListObj) {
          let list = newListObj[key];
          if (new Set(list).size !== list.length) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000455'));
            v.scrollToError();
            return false;
          }
        }
        query.values = v.optionalValuesData.map((item) => {
          let {addTalg, ...obj} = item;
          obj.introduction = item.introduction ? item.introduction : null;
          obj.referenceImagePath = item.referenceImagePath ? item.referenceImagePath : null;
          return obj;
        });
        if (v.addAttributesTalg === 'add') {
          method = 'post';
          url = api.post_ymsProductAttributeTemplate;
          txt = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456');
        } else if (v.addAttributesTalg === 'edit') {
          method = 'put';
          url = api.put_ymsProductAttributeTemplate;
          txt = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155');
        }
        v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data.code === 1112735) {
              let cnValues = data.cnValues || []; // 属性值
              let cnNames = data.cnNames || []; // 属性名
              if (cnNames.length > 0) {
                let cnName = cnNames[0];
                v.$Message.warning(`${cnName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000425')}`);
                return false;
              }
              if (cnValues.length > 0) {
                let cnValue = cnValues[0];
                v.$Message.warning(`${cnValue}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000426')}`);
                return false;
              }
            } else {
              v.$Message.success(txt);
              v.addAttributesModal = false;
              v.$emit('updateData', {
                ymsProductAttributeTemplateId: data.ymsProductAttributeTemplateId,
                attributeType: v.addAttributesForm.attributeType
              });
            }
          }
        });
      }
    },
    // 自动滚动到异常提示框可见范围
    scrollToError() {
      let v = this;
      setTimeout(() => {
        let tableBody = v.$refs['tableDom'].$el.querySelector('.ivu-table-body');
        let errorElements = tableBody.querySelectorAll('.ivu-form-item-error, .redColor');
        if (tableBody && errorElements.length > 0) {
          let firstErrorElement = errorElements[0];
          let errorRect = firstErrorElement.getBoundingClientRect();
          let tableBodyRect = tableBody.getBoundingClientRect();

          // 计算需要滚动的距离
          let scrollTop = errorRect.top - tableBodyRect.top + tableBody.scrollTop;
          let scrollLeft = errorRect.left - tableBodyRect.left + tableBody.scrollLeft;

          // 调整滚动条的位置
          tableBody.scrollTop = scrollTop;
          tableBody.scrollLeft = scrollLeft;
        }
      }, 1500);
    },
    // 添加属性单位
    addAttributeUnit() {
      let v = this;
      let sortNo = v.attributeUnitData.length + 1;
      let obj = {
        cnValue: '',
        deValue: '',
        usValue: '',
        ukValue: '',
        auValue: '',
        euValue: '',
        esValue: '',
        frValue: '',
        itValue: '',
        nlValue: '',
        plValue: '',
        ptValue: '',
        roValue: '',
        sortNo: sortNo,
        status: 1,
        addTalg: true
      };
      v.attributeUnitData.push(obj);
      v.optionalValuesData.push(obj);
      // 添加属性值后，自动滚动到底部展示新添加的属性
      v.$nextTick(() => {
        const tableContainer = document.querySelector('.attributeUnitTableDom .ivu-table-body');
        tableContainer.scrollTop = tableContainer.scrollHeight;
      });
    },
    // 添加可选值
    addOptional() {
      let v = this;
      let sortNo = v.optionalTableData.length + 1;
      let obj = {
        cnValue: '',
        deValue: '',
        usValue: '',
        ukValue: '',
        auValue: '',
        euValue: '',
        esValue: '',
        frValue: '',
        itValue: '',
        nlValue: '',
        plValue: '',
        ptValue: '',
        roValue: '',
        sortNo: sortNo,
        status: 1,
        addTalg: true,
        introduction: '',
        referenceImagePath: ''
      };
      v.optionalTableData.push(obj);
      v.optionalValuesData.push(obj);
      // 添加属性值后，自动滚动到底部展示新添加的属性
      v.$nextTick(() => {
        const tableContainer = document.querySelector('.attributeValuetableDom .ivu-table-body');
        tableContainer.scrollTop = tableContainer.scrollHeight;
      });
    },
    // 自动滚动到最左边
    scrollToLeft() {
      let tableBody = this.$refs['tableDom'] ? this.$refs['tableDom'].$el.querySelector('.ivu-table-body') : null;
      if (tableBody) {
        tableBody.scrollLeft = 0;
      }
    },
    // 监听新增属性的弹窗
    addAttributesChange(value) {
      let v = this;
      if (!value) {
        v.$nextTick(() => {
          v.$refs['addAttributesForm'].resetFields();
          v.scrollToLeft();
        });
        v.attrTableData = [{
          cnName: '',
          deName: '',
          usName: '',
          ukName: '',
          auName: '',
          euName: '',
          esName: '',
          frName: '',
          itName: '',
          nlName: '',
          plName: '',
          ptName: '',
          roName: '',
        }];
        // 属性名称列表
        v.optionalTableData = [{
          cnValue: '',
          deValue: '',
          usValue: '',
          ukValue: '',
          auValue: '',
          euValue: '',
          esValue: '',
          frValue: '',
          itValue: '',
          nlValue: '',
          plValue: '',
          ptValue: '',
          roValue: '',
          sortNo: 1,
          status: 1,
          addTalg: true
        }];
        // 属性单位列表
        v.attributeUnitData = [{
          cnValue: '',
          deValue: '',
          usValue: '',
          ukValue: '',
          auValue: '',
          euValue: '',
          esValue: '',
          frValue: '',
          itValue: '',
          nlValue: '',
          plValue: '',
          ptValue: '',
          roValue: '',
          sortNo: 1,
          status: 1,
          addTalg: true,
          introduction: '',
          referenceImagePath: ''
        }];
        // 可选值列表
        v.optionalValuesData = JSON.parse(JSON.stringify(v.optionalTableData));
        v.repeatObj = {};
        v.attributePoolList = [];
        v.attributeNameObj = {};
        v.isAllowCustomValue = false;
        v.isAllowCustomValueTalg = false;
        v.attributeTypeTalg = false;
        v.newAttributeTalg = false;
        v.addAttributesForm.chooseType = 0;
        v.sizeGroupNameList = [];
      }
    },
    // 获取物品属性池列表的数据
    getAttributePoolData() {
      let v = this;
      if (v.getPermission('ymsProductAttributeTemplate_query')) {
        let query = {
          attributeRequire: null, // 属性填写要求，0：必填，1：非必填，2：选填
          attributeType: null, // 属性类型(0:基础属性 1:规格属性 null 全部)
          chooseType: null, // 可选值类型定义 0:多选 1:单选
          isProportion: null, // 是否需填写比例 0:否 1:是
          isAllowCustomValue: null, // 是否允许自定义属性值(0:不允许 1:允许)
          isSizeAttribute: null, // 是否尺码属性，0：否，1：是
          name: '',
          status: null, // 状态 0 停用 1 启用
          orderBy: 'createdTime',
          upDown: 'down',
          ymsSiteId: v.addAttributesForm.ymsSiteId
        };
        v.axios.post(api.post_ymsProductAttributeTemplate_query, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.attributePoolList = data || [];
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 拖拽排序
    dragDrop(oldIndex, newIndex) {
      let v = this;
      v.optionalTableData[oldIndex] = v.optionalTableData.splice(newIndex, 1, v.optionalTableData[oldIndex])[0];
      v.optionalTableData.map((item, index) => {
        item.sortNo = index + 1;
      });
      v.optionalValuesData[oldIndex] = v.optionalValuesData.splice(newIndex, 1, v.optionalValuesData[oldIndex])[0];
      v.optionalValuesData.map((item, index) => {
        item.sortNo = index + 1;
      });
      v.draggable = false;
      v.$forceUpdate();
    },
    // 上传参考图片成功
    uploadSuccess(response, file, fileList, currentIndex) {
      let v = this;
      if (response.code === 0) {
        let imgUrl = response.datas[0];
        v.optionalValuesData[currentIndex]['referenceImagePath'] = imgUrl;
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457'));
      }
    },
    // 取消选中的尺码组名
    changeValue(value) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000458'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000459'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000460'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          let newList = v.sizeGroupNameList.filter((key) => {
            return key !== value;
          });
          v.sizeGroupNameList = [...newList];
          v.optionalValuesData.map((item) => {
            for (let key in item) {
              if (key === value) {
                item[key] = '';
              }
            }
          });
          v.$forceUpdate();
        },
        onCancel: () => {
        }
      });
    },
    // 处理可选值的列表字段
    handleColumns() {
      let v = this;
      let columnsList = [
        {
          title: '',
          key: 'sort',
          align: 'center',
          width: 60,
          renderHeader: (h) => {
            return h('span', '');
          },
          render: (h) => {
            return h('div', {
              class: 'cursor-move',
              on: {
                mousedown() {
                  v.draggable = true;
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                class: 'cursor-move'
              })
            ]);
          }
        },
        {
          type: 'index',
          key: 'currentIndex',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          width: 100,
          render: (h, params) => {
            let status = v.optionalValuesData[params.index].status;
            let text = status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463');
            return h('span', {class: status === 1 ? 'themeColor' : 'deleteColor'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000464'),
          key: 'referenceImagePath',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            let referenceImagePath = v.optionalValuesData[params.index].referenceImagePath || '';
            let list = [
              !referenceImagePath && v.addAttributesTalg !== 'look' ? h('Upload', {
                props: {
                  type: "drag",
                  name: "files",
                  headers: v.headObj,
                  maxSize: v.uploadFilesMaxSize,
                  onExceededSize: v.uploadExceedSize,
                  showUploadList: false,
                  format: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
                  onSuccess: (response, file, fileList) => v.uploadSuccess(response, file, fileList, params.index),
                  onError: v.uploadFilesError,
                  onFormatError: v.handleFormatError,
                  action: v.fileApi
                },
                style: {
                  display: 'inline-block',
                  width: '80px',
                  margin: '10px 0'
                },
              }, [
                h('div', {class: 'flex flex-direction align-items-center justify-content-center'}, [
                  h('i',
                    {
                      class: 'iconfont upload-icon',
                      domProps: {
                        innerHTML: '&#xe68d;'
                      },
                      style: {
                        fontSize: '24px'
                      }
                    }
                  ),
                  h('p', {style: {fontSize: '12px', marginBottom: '5px'}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000465'))
                ])
              ]) : '',
              referenceImagePath ? h('div', {
                class: 'referencePictureStyles'
              }, [
                v.tableImg(h, params, null, referenceImagePath),
                v.addAttributesTalg !== 'look' ? h('Icon', {
                  props: {
                    type: 'ios-trash-outline'
                  },
                  class: 'referencePictureIcon',
                  on: {
                    click: () => {
                      v.optionalValuesData[params.index]['referenceImagePath'] = '';
                    }
                  }
                }) : ''
              ]) : ''
            ];
            return h('div', list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000466'),
          key: 'introduction',
          align: 'center',
          minWidth: 240,
          render: (h, params) => {
            let introduction = v.optionalValuesData[params.index].introduction || '';
            return h('Input', {
              props: {
                type: 'textarea',
                value: introduction,
                disabled: v.addAttributesTalg === 'look',
                maxlength: 200
              },
              style: {
                width: '200px',
                margin: '10px 0'
              },
              on: {
                input: (val) => {
                  v.optionalValuesData[params.index]['introduction'] = val.trim();
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 100,
          fixed: 'right',
          render(h, params) {
            let addTalg = params.row.addTalg || false;
            let reduceTalg;
            let status = v.optionalValuesData[params.index].status;
            if (v.attributeUnitTalg) {
              reduceTalg = v.attributeUnitData.length > 1;
            } else {
              reduceTalg = v.optionalTableData.length > 1;
            }
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && !addTalg && v.addAttributesTalg !== 'look' && v.getPermission('ymsProductAttributeDictionary_enable'),
                    clickFn: () => {
                      v.optionalValuesData[params.index].status = 1;
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && !addTalg && v.addAttributesTalg !== 'look' && v.getPermission('ymsProductAttributeDictionary_disable'),
                    color: '#FF0000',
                    clickFn: () => {
                      v.optionalValuesData[params.index].status = 0;
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: reduceTalg && addTalg && v.addAttributesTalg !== 'look',
                    clickFn: () => {
                      if (v.attributeUnitTalg) {
                        v.attributeUnitData.splice(params.index, 1);
                      } else {
                        v.optionalTableData.splice(params.index, 1);
                      }
                      v.optionalValuesData.splice(params.index, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let columnsData = [];
      v.sizeGroupNameData.map((item) => {
        let name = v.attributeUnitTalg ? `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000427')}${item.name}）` : item.name;
        columnsData.push({
          title: name,
          key: item.key,
          align: 'center',
          minWidth: 200,
          renderHeader: (h, params) => {
            return h('div', {class: 'flex align-items-center'}, [
              h('span', {class: 'required'}, name),
            ]);
          },
          render: (h, params) => v.handleSizeVerification(h, params, item.key)
        });
      });
      let introductionIndex = columnsList.findIndex(col => col.key === 'introduction');
      columnsList.splice(introductionIndex + 1, 0, ...columnsData);
      let tableColumns = columnsList;
      let defaultKeyList = ['sort', 'currentIndex', 'status', 'referenceImagePath', 'introduction', 'cnValue', 'options'];
      let keyList = [...defaultKeyList, ...this.sizeGroupNameList];
      this.optionalTableColumns = tableColumns.filter((item) => {
        return keyList.includes(item.key);
      });
      // 属性单位
      let attributeUnitkeyList = ['currentIndex', 'status', 'cnValue', 'options', ...this.sizeGroupNameList];
      this.attributeUnitColumns = tableColumns.filter((item) => {
        return attributeUnitkeyList.includes(item.key);
      });
      this.updateTableDom('tableDom', 1000, true, 'optionalTableData');
      this.updateTableDom('attributeUnitDom', 1000, true, 'attributeUnitData');
    },
    // 处理尺码校验与展示
    handleSizeVerification(h, params, key) {
      let v = this;
      let value = v.optionalValuesData[params.index][key];
      let list = v.repeatObj[key] || [];
      let talg = list.includes(value);
      let required = !value;
      let text = '';
      if (v.attributeUnitTalg) {
        text = required ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000467') : talg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000468') : '';
      } else {
        let txt = v.addAttributesForm.isSizeAttribute === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000469') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000470');
        text = required ? txt : talg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000471') : '';
      }
      return h('div', [
        h('Input', {
          props: {
            value: value,
            disabled: v.addAttributesTalg === 'look'
          },
          style: {
            width: '130px'
          },
          class: (required || talg) ? 'ivu-form-item-error' : '',
          on: {
            input: (val) => {
              v.optionalValuesData[params.index][key] = val.trim();
            }
          },
        }),
        (required || talg) ? h('p', {class: 'redColor mt4'}, text) : ''
      ]);
    },
    // 处理属性名称
    attributeNameRender(h, params) {
      let v = this;
      let key = params.column.key;
      let list = v.attributeNameObj[key] || [];
      let talg = list.includes(params.row[key]);
      return h('Input', {
        props: {
          value: params.row[key],
          disabled: v.addAttributesTalg === 'look'
        },
        class: talg ? 'ivu-form-item-error' : '',
        style: {
          width: '90px'
        },
        on: {
          input: (val) => {
            v.$set(v.attrTableData[params.index], key, val.trim());
          }
        }
      });
    },
    // 切换属性值类型
    typeChange(value) {
      const defaultItem = {
        cnValue: '',
        deValue: '',
        usValue: '',
        ukValue: '',
        auValue: '',
        euValue: '',
        esValue: '',
        frValue: '',
        itValue: '',
        nlValue: '',
        plValue: '',
        ptValue: '',
        roValue: '',
        sortNo: 1,
        status: 1,
        addTalg: true,
        introduction: '',
        referenceImagePath: '',
      };
      if (value === 0) {
        this.attributeUnitData = [defaultItem];
        this.optionalValuesData = [defaultItem];
      } else {
        this.optionalTableData = [defaultItem];
        this.optionalValuesData = [defaultItem];
      }
    }
  },
  watch: {
    // 监听规格/普通属性
    'addAttributesForm.attributeType': {
      handler(val) {
        if (val === 1) {
          this.isAllowCustomValueTalg = true;
          this.isAllowCustomValue = false;
          this.addAttributesForm.type = 1;
        } else {
          this.isAllowCustomValueTalg = false;
        }
      },
      deep: true,
      immediate: true
    },
    // 监听是否尺码属性
    'addAttributesForm.isSizeAttribute': {
      handler() {
        this.handleColumns();
      }
    },
    // 监听尺码组名
    sizeGroupNameList: {
      handler(data) {
        this.handleColumns();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.addAttributesStyle /deep/ {
  .title_box {
    color: #333;
    font-size: 15px;
    font-weight: 700;
    background-color: #fff;
  }

  .radio_styles {
    .ivu-form-item-content label.ivu-radio-default {
      font-size: 12px;
    }
  }

  .table_box {
    /deep/ .referencePictureStyles {
      margin: 10px 0;
      position: relative;

      .referencePictureIcon {
        cursor: pointer;
        color: #2D8CF0;
        font-size: 21px;
        position: absolute;
        top: 0;
        right: -18px;
      }
    }

    .sizeGroupName_box {
      position: relative;
      margin: 0 35px 12px 0;

      .sizeGroupName_item {
        display: inline-block !important;
        margin: 0 !important;
      }

      .options_item {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 10;
        cursor: pointer;
        margin: 0;
      }
    }
  }
}
</style>
